<template>
  <div class="common-list">
    <selector select="selector-order" @handleTicketOrder="handleTicketOrder"></selector>
    <router-view v-if="totalCount > 0"></router-view>
    <emptyContent text="You have no order history." v-else></emptyContent>
  </div>
</template>

<script>
import selector from "@/components/entry/buyTicketHomeEn/selector";
// import orderTypes from "@/components/orderEn/orderlist/types";
import { getEffective } from "@/service/order/orderlist.js";

export default {
  name: "orderlist",
  data() {
    return {
      userInfo: {},
      perPageSize: 5,
      pageNo: 1,
      orderTypeList: [],
      totalCount: 0
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
    this.generateOrderOption();
  },
  methods: {
    async generateOrderOption() {
      const parameter = {
        userId: this.userInfo.userId,
        perPageSize: this.perPageSize,
        pageNo: this.pageNo,
        deleteFlag: "0"
      };
      const { data } = await getEffective.call(this, parameter);
      this.$store.commit("setOrderListPool", {
        data: data,
        key: "individualOrder"
      });
      this.totalCount = Number(data.totalCount);
    },
    handleTicketOrder() {
      this.$router.push("/buytickethomeEn/0/0");
    }
  },
  components: {
    // orderTypes,
    selector
  },
  beforeDestroy() {
    this.$store.commit("setOrderListPool", { data: {}, key: "individualOrder" });
  }
};
</script>
